/* eslint-disable @typescript-eslint/no-loop-func */
import * as angular from 'angular';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { SpeqsController } from '../../ib-speqs-component/controller/ib-modal-speqs-controller';

export class NewSeatsMapTransformer {

    constructor (
        private $rootScope: CommonsRootScope,
        private $filter: ng.IFilterService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $window: ng.IWindowService) { }


    ////////////////
    generateSeatsMapRequest = (seatsInfo: any, identifiers: any, cachedInfo: any): any => {

        let i, j, k, l, infoFound, columnSize = 3, maximumColumnSize = 3, actualSeatPrice = null, maximumAisles = 0;
        const orderInformation = this.localStorageService.get('createOrderData');
        const returnInfo: any = {
            segmentInfo: {},
            columnsInfo: [],
            passengersInfo: [],
            currentPassengerIndex: 0,
            flightMap: {},
            currency: {},
            legend: [],
            isFirstSegment: false,
            isLastSegment: false,
            totalPrice: 0,
            pricesProvider: ''
        };

        /**
        * Generate information of passengers in CHECKIN flow
        * @param {Object} cachedData Information of booking recovered
        * @param {String} currentPasId Passenger ID
        */
        const generatePassengerInfoCheckin = (cachedData, currentPasId): any => {
            const passengersData: any = { passengersInfo: [], currentPassengerIndex: 0 };
            const passengersSelected: any = this.localStorageService.get('passengersSelected');
            cachedData.passengers = cachedData.passengers || [];
            const generatePasenger=(passenger:any):any=> {
                return {
                    id: passenger.id,
                    name: passenger.name + ' ' + passenger.surname,
                    type: passenger.type,
                    resiberId: passenger.resiberId,
                    infant: passenger.infant,
                    initialSeat: null,
                    currentSeat: null,
                    seatPrice: 0
                };
            };
            for (let pasIndex = 0; pasIndex < cachedData.passengers.length; pasIndex++) {
                for (let i = 0; i < passengersSelected.length; i++) {
                    if (passengersSelected[i] === cachedData.passengers[pasIndex].id) {
                        passengersData.passengersInfo.push(generatePasenger(cachedData.passengers[pasIndex]));
                        if (Number(currentPasId) === Number(cachedData.passengers[pasIndex].id)) {
                            passengersData.currentPassengerIndex = passengersData.passengersInfo.length - 1;
                        }
                    }
                }

            }

            return passengersData;
        };


        const generatePassengerInfo = (cachedData: any, identifiers: any, orderInformation: any): any => {
            const passengersData = { passengersInfo: [], currentPassengerIndex: 0 };
            const infants = [];
            cachedData.passengers = cachedData.passengers || [];

            const generatePasenger=(passenger:any, infants:any):any => {
                const getCorrectName=(passenger:any):any=> {
                    let correctName = passenger.personalInfo.name + ' ' + passenger.personalInfo.surname;
                    if (passenger.externalPersonalInfo) {
                        correctName = passenger.externalPersonalInfo.name + ' ' + passenger.externalPersonalInfo.firstSurname + (passenger.externalPersonalInfo.lastSurname !== '' ? ' ' + passenger.externalPersonalInfo.lastSurname : '');
                    }
                    return correctName;
                };
                return {
                    id: passenger.passengerId,
                    name: getCorrectName(passenger),
                    type: passenger.passengerType,
                    infant: getRelatedInfant(passenger.passengerId, infants),
                    resiberId: passenger.resiberId,
                    initialSeat: null,
                    currentSeat: null,
                    seatPrice: 0
                };

            };
            const getRelatedInfant=(adultId:any, infants:any):any => {
                let adultIdInfantIndex = 0, foundedAdultInfant = false, foundedInfant = null;
                while (!foundedAdultInfant && adultIdInfantIndex < infants.length) {
                    if (adultId === infants[adultIdInfantIndex].relatedPassengerId) {
                        foundedInfant = infants[adultIdInfantIndex];
                        foundedAdultInfant = true;
                    }
                    adultIdInfantIndex++;
                }
                return foundedInfant;
            };
            for (let pasIndex = 0; pasIndex < cachedData.passengers.length; pasIndex++) {
                if (cachedData.passengers[pasIndex].passengerType === 'INFANT') {
                    if (orderInformation && orderInformation.passengers) {
                        orderInformation.passengers.forEach((passenger) => {
                            if (cachedData.passengers[pasIndex].passengerId === passenger.passengerId) {
                                cachedData.passengers[pasIndex].relatedPassengerId = passenger.relatedPassengerId;
                            }
                        });
                    }
                    infants.push(cachedData.passengers[pasIndex]);
                }
            }
            for (let pasIndex = 0; pasIndex < cachedData.passengers.length; pasIndex++) {
                if (cachedData.passengers[pasIndex].passengerType !== 'INFANT') {
                    passengersData.passengersInfo.push(generatePasenger(cachedData.passengers[pasIndex], infants));
                    if (identifiers.pasId === cachedData.passengers[pasIndex].passengerId) {
                        passengersData.currentPassengerIndex = passengersData.passengersInfo.length - 1;
                    }
                }
            }
            return passengersData;
        };


        /**
         * Generate information of segments in CHECKIN flow
         * @param {*} segmentId
         * @param {*} cachedData
         */
        const generateSegmentInfoCheckin = (segmentId: any, cachedData: any) => {
            const generateSegment = (segment): any => {
                return {
                    id: segment.id,
                    departure: segment.departure.airport,
                    arrival: segment.arrival.airport,
                    date: this.$filter<any>('DateFormatFilter')(segment.departure.date),
                    dateFormatted: this.AncillariesUtilsService.formatDate(segment.departure.date),
                    cabinClassDescription: segment.cabinClass.description,
                    cabinClass: this.AncillariesUtilsService.getCabinClassName(segment.cabinClass.type),
                    cabinClassType: segment.cabinClass.type,
                    cabinClassCode: segment.cabinClass.code,
                    companyCode: segment.operatingFlightNumber.company.code,
                    aircraft: {code: segment.aircraft.model, description:''}
                };
            };

            let found = false, segmentIndex = 0, returnedSegmentInfo: any = {}, segmentComplete;
            cachedData.outwardSegments = cachedData.outwardSegments || [];
            cachedData.returnSegments = cachedData.returnSegments || [];
            if (cachedData.airShuttleSegments && cachedData.airShuttleSegments.length > 0) {
                while (!found && segmentIndex < cachedData.airShuttleSegments.length) {
                    if (segmentId === cachedData.airShuttleSegments[segmentIndex].id) {
                        found = true;
                        returnedSegmentInfo = generateSegment(cachedData.airShuttleSegments[segmentIndex]);
                        segmentComplete = cachedData.airShuttleSegments[segmentIndex];
                    }
                    segmentIndex++;
                }
            } else {
                while (!found && segmentIndex < cachedData.outwardSegments.length) {
                    if (segmentId === cachedData.outwardSegments[segmentIndex].id) {
                        found = true;
                        returnedSegmentInfo = generateSegment(cachedData.outwardSegments[segmentIndex]);
                        returnedSegmentInfo.isOut = true;
                        segmentComplete = cachedData.outwardSegments[segmentIndex];
                    }
                    segmentIndex++;
                }
                segmentIndex = 0;
                while (!found && segmentIndex < cachedData.returnSegments.length) {
                    if (segmentId === cachedData.returnSegments[segmentIndex].id) {
                        found = true;
                        returnedSegmentInfo = generateSegment(cachedData.returnSegments[segmentIndex]);
                        returnedSegmentInfo.isOut = false;
                        segmentComplete = cachedData.returnSegments[segmentIndex];
                    }
                    segmentIndex++;
                }

            }
            return { returnedSegmentInfo: returnedSegmentInfo, segmentComplete: segmentComplete };
        };

        /**
       * Generate information of segments in GDR || BOOKING flow
       * @param {*} segmentId
       * @param {*} cachedData
       */
        const generateSegmentInfo = (segmentId: any, cachedData: any): any => {
            let isFound = false, segmentIndex = 0, returnedSegmentInfo = {}, segmentComplete = {};

            const generateSegment = (segment) => {
                return {
                    id: segment.id,
                    departure: { code: segment.departure.code, description: segment.departure.city ? segment.departure.city.description : segment.departure.name },
                    arrival: { code: segment.arrival.code, description: segment.arrival.city ? segment.arrival.city.description : segment.arrival.name },
                    date: this.$filter<any>('DateFormatFilter')(segment.departureDateTime),
                    dateFormatted: this.AncillariesUtilsService.formatDate(segment.departureDateTime),
                    mobileDateFormat: this.$filter('date')(new Date(segment.departureDateTime), 'dd/MM'),
                    cabinClass:  this.AncillariesUtilsService.getCabinClassName(segment.cabin.type),
                    cabinClassDescription:  segment.cabin.description,
                    cabinClassType: segment.cabin.type,
                    cabinClassCode: segment.cabin.code,
                    companyCode: segment.flight.operationalCarrier.code,
                    aircraft: segment.flight.aircraft
                };
            };
            while (!isFound && segmentIndex < cachedData.order.slices.length) {
                angular.forEach(cachedData.order.slices[segmentIndex].segments, (segment) => {
                    if (segmentId === segment.id) {
                        isFound = true;
                        returnedSegmentInfo = generateSegment(segment);
                        segmentComplete = cachedData.passengers;
                    }
                });
                segmentIndex++;
            }
            return { returnedSegmentInfo: returnedSegmentInfo, segmentComplete: segmentComplete };


        };

        const generateColumns = (cabins: any): any => {
            const generateCabinColumns = (cabinColumns: any): any => {
                const returnColumns = [];
                for (let columnIndex = 0; columnIndex < cabinColumns.length; columnIndex++) {
                    if (cabinColumns[columnIndex].type === this.AncillariesConstants.SeatTypes.seat) {
                        returnColumns.push({
                            name: cabinColumns[columnIndex].name,
                            beforeGAP: false
                        });
                    } else if (returnColumns.length > 0) {
                        returnColumns[returnColumns.length - 1].beforeGAP = true;
                    }
                }
                return returnColumns;
            };
            let columns = [], cabinIndex = 0, found = false, i, j, auxColumn, auxAisles;
            cabins = cabins || [];
            while (!found && cabinIndex < cabins.length) {
                if (cabins[cabinIndex].enabled) {
                    found = true;
                    columns = generateCabinColumns(cabins[cabinIndex].columns);
                    if (columns.length > 0) {
                        columns[columns.length - 1].beforeGAP = false;
                    }
                }
                cabinIndex++;
            }
            for (i = 0; i < cabins.length; i++) {
                auxColumn = 0;
                auxAisles = 0;
                for (j = 0; j < cabins[i].columns.length; j++) {
                    if (cabins[i].columns[j].type === 'SEAT') {
                        auxColumn++;
                    } else if(cabins[i].columns[j].type === 'AISLE') {
                        auxAisles++;
                    }
                }
                if (auxColumn > maximumColumnSize) {
                    maximumColumnSize = auxColumn;
                }
                if (auxAisles > maximumAisles) {
                    maximumAisles = auxAisles;
                }
            }
            return columns;
        };

        const processWarningMessages = (warningMessages: any): any => {
            const returnedWarnMessages = { applyingFeatures: [], discardingFeatures: [] };
            let wIndex = 0;
            warningMessages = warningMessages || [];
            const transformEmergencyMessage =(messageTransform:any):any => {
                let messageReturn =  '<p>' + messageTransform ;
                messageReturn = messageReturn.replace(new RegExp('<ul>', 'g'), '</p><ul class="ib-new-map-seats__modal-seat--text ib-new-map-seats__modal-seat--text--list">');
                messageReturn = messageReturn.replace(new RegExp('</ul>', 'g'), '</ul><p class="ib-new-map-seats__modal-seat--text">');
                return messageReturn;
            };
            for (wIndex = 0; wIndex < warningMessages.length; wIndex++) {
                if (warningMessages[wIndex].passengers.length > 0) {
                    if (warningMessages[wIndex].discardingFeatures.length > 0) {
                        returnedWarnMessages.discardingFeatures.push(warningMessages[wIndex]);
                    } else if (warningMessages[wIndex].applyingFeatures.length > 0) {
                        if (warningMessages[wIndex].applyingFeatures.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) !== -1) {
                            warningMessages[wIndex].message = transformEmergencyMessage(warningMessages[wIndex].message);
                        }
                        returnedWarnMessages.applyingFeatures.push(warningMessages[wIndex]);
                    }
                }
            }
            return returnedWarnMessages;
        };

        const generateFlightMapInformation = (seatData: any, currency: any, columnsSize: any, columnsAisles): any => {
            const returnedMapInfo: any = {};
            if (seatData.aircraft !== null) {
                returnedMapInfo.aircraft = seatData.aircraft.model;
            }
            returnedMapInfo.allCabinsAvailable = seatData.allCabinsAvailable;
            returnedMapInfo.cabins = [];
            const generateFeatures=(features:any, warningMessages:any):any =>{
                const seatFeatures = [], tooltipMessages = [], rowFeatures = [];
                let seatTypeMessasge = this.$filter('translate')('STANDAR_TYPE_SEAT'), seatTypeDescription = '', typeSeat = '';
                features = features || [];
                const modalMessages = warningMessages.discardingFeatures.slice();
                const getApplyingFeatures = (feature: any, applyingFeatures: any): any => {
                    let iFeature = 0, featurefound = false;
                    let aFeature = null;
                    while (!featurefound && iFeature < applyingFeatures.length) {
                        if (applyingFeatures[iFeature].applyingFeatures.indexOf(feature) !== -1) {
                            featurefound = true;
                            aFeature = applyingFeatures[iFeature];
                        }
                        iFeature++;
                    }
                    return aFeature;
                };

                const getDescriptionFeatureType = (type: any): any => {
                    switch (type) {
                            case this.AncillariesConstants.SeatFeatures.emergencyExit: return this.$filter('translate')('CKIANCSEATS_SEAT_EMERGENCY_XL');
                            case this.AncillariesConstants.SeatFeatures.extraSize: return this.$filter('translate')('SEATS_EXTRA_SIZE_SEAT');
                            case this.AncillariesConstants.SeatFeatures.promo: return this.$filter('translate')('SEATS_SEAT_PROMO');
                            case this.AncillariesConstants.SeatFeatures.infant: return this.$filter('translate')('CKIANCSEATS_SEAT_INFANT');
                            case this.AncillariesConstants.SeatFeatures.mobility: return this.$filter('translate')('CKIANCSEATS_SEAT_HANDICAP');
                            case this.AncillariesConstants.SeatFeatures.upfront: return this.$filter('translate')('CKIANCSEATS_SEAT_UPFRONT');
                            default: return '';
                    }
                };
                for (let fIndex = 0; fIndex < features.length; fIndex++) {
                    seatFeatures.push(features[fIndex]);
                    if (features[fIndex] === this.AncillariesConstants.SeatFeatures.emergencyExit ||
                        features[fIndex] === this.AncillariesConstants.SeatFeatures.wing) {
                        rowFeatures.push(features[fIndex]);
                    }
                    const featureMessage = this.$filter('translate')(features[fIndex] + '_SEAT');
                    if (featureMessage && featureMessage !== (features[fIndex] + '_SEAT')) {
                        tooltipMessages.push(featureMessage);
                    }
                    for (let mIndex = 0; mIndex < modalMessages.length; mIndex++) {
                        if (modalMessages[mIndex].discardingFeatures.indexOf(features[fIndex]) !== -1) {
                            modalMessages.splice(mIndex, 1);
                            mIndex--;
                        }
                    }
                    const modalMessage = getApplyingFeatures(features[fIndex], warningMessages.applyingFeatures);
                    if (modalMessage !== null) {
                        modalMessages.push(modalMessage);
                    }

                    if (features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('EMERGENCY_XL_TYPE_SEAT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.emergencyExit;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) === -1 && features.indexOf(this.AncillariesConstants.SeatFeatures.extraSize) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('SEATS_SEAT_COMFORT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.extraSize;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.infant) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('PASSENGER_WITH_INFANT_TYPE_SEAT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.infant;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.promo) !== -1 && features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) === -1) {
                        seatTypeMessasge = this.$filter('translate')('PROMO_TYPE_SEAT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.promo;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.promo) !== -1 && features.indexOf(this.AncillariesConstants.SeatFeatures.infant) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('PASSENGER_WITH_INFANT_TYPE_SEAT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.infant;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.upfront) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('CKIANCSEATS_SEAT_UPFRONT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.upfront;
                    } if (features.indexOf(this.AncillariesConstants.SeatFeatures.mobility) !== -1) {
                        seatTypeMessasge = this.$filter('translate')('RESTRICTED_MOBILITY_TYPE_SEAT');
                        typeSeat = this.AncillariesConstants.SeatFeatures.mobility;
                    }

                    typeSeat !== '' ? seatTypeDescription = getDescriptionFeatureType(typeSeat) : seatTypeDescription = '';
                }

                return {
                    features: seatFeatures, tooltipMessages: tooltipMessages, rowFeatures: rowFeatures, modalMessages: modalMessages,
                    seatTypeMessasge: seatTypeMessasge, seatTypeDescription: seatTypeDescription, seatType: typeSeat
                };

            };
            const generateSeatMap =(seatsInfo:any, index:any, currency:any):any=> {
                let rowIndex, seatIndex, auxRowFeatures;
                const returnedMap = [];
                for (rowIndex = 0; rowIndex < seatsInfo.cabins[index].map.length; rowIndex++) {
                    const rowAux = { rowFeatures: [], row: '', rowSeats: [] };
                    for (seatIndex = 0; seatIndex < seatsInfo.cabins[index].map[rowIndex].length; seatIndex++) {
                        const seatAux: any = {
                            row: seatsInfo.cabins[index].map[rowIndex][seatIndex].row,
                            column: seatsInfo.cabins[index].map[rowIndex][seatIndex].column,
                            type: seatsInfo.cabins[index].map[rowIndex][seatIndex].type,
                            occupation: seatsInfo.cabins[index].map[rowIndex][seatIndex].occupation,
                            passengersAllowed: seatsInfo.cabins[index].map[rowIndex][seatIndex].passengersAllowed,
                            passengersPrice: getPassengersSeatPrice(seatsInfo.cabins[index].map[rowIndex][seatIndex].passengerPrices, seatsInfo.seatPriceInfo.seatPrices),
                            originalType: getPassengersOriginalType(seatsInfo.cabins[index].map[rowIndex][seatIndex].passengerPrices, seatsInfo.seatPriceInfo.seatPrices)
                        };
                        seatAux.passengersPriceLabels = getSeatPriceLabel(seatAux.passengersPrice, currency);
                        const fullFeatures = generateFeatures(seatsInfo.cabins[index].map[rowIndex][seatIndex].features, seatsInfo.warningMessages);
                        seatAux.features = fullFeatures.features;
                        seatAux.seatTypeDescription = fullFeatures.seatTypeDescription;
                        seatAux.seatType = fullFeatures.seatType;
                        seatAux.tooltipMessages = fullFeatures.tooltipMessages;
                        seatAux.modalMessages = fullFeatures.modalMessages;
                        seatAux.seatTypeMessasge = fullFeatures.seatTypeMessasge;
                        for (auxRowFeatures = 0; auxRowFeatures < fullFeatures.rowFeatures.length; auxRowFeatures++) {
                            if (rowAux.rowFeatures.indexOf(fullFeatures.rowFeatures[auxRowFeatures]) === -1) {
                                rowAux.rowFeatures.push(fullFeatures.rowFeatures[auxRowFeatures]);
                            }
                        }
                        rowAux.rowSeats.push(seatAux);
                        rowAux.row = seatsInfo.cabins[index].map[rowIndex][seatIndex].row;
                    }
                    returnedMap.push(rowAux);
                }
                return returnedMap;


            };
            for (let cabinIndex = 0; cabinIndex < seatData.cabins.length; cabinIndex++) {
                const cabinAux = {
                    enabled: seatData.cabins[cabinIndex].enabled,
                    cabinClass: seatData.cabins[cabinIndex].cabinClass,
                    columns: seatData.cabins[cabinIndex].columns,
                    seatMap: generateSeatMap(seatData, cabinIndex, currency),
                    columnsSize: columnsSize,
                    columnsAisles: columnsAisles,
                    zones: seatData.cabins[cabinIndex].zones.filter((zone: any) => zone.passengerPrices.length > 0),
                    layoutSeat3D: seatData.cabins[cabinIndex].layoutSeat3D
                };
                returnedMapInfo.cabins.push(cabinAux);
            }
            return returnedMapInfo;
        };

        const generateSeatInformationCheckin = () => {
            for (i = 0; i < returnInfo.passengersInfo.length; i++) {
                infoFound = false; j = 0;
                while (!infoFound && j < allSegmentInfo.segmentComplete.passengers.length) {
                    if (allSegmentInfo.segmentComplete.passengers[j].id === returnInfo.passengersInfo[i].id) {
                        infoFound = true;
                        returnInfo.passengersInfo[i].initialSeat = {
                            row: allSegmentInfo.segmentComplete.passengers[j].seat ? allSegmentInfo.segmentComplete.passengers[j].seat.row : '',
                            column: allSegmentInfo.segmentComplete.passengers[j].seat ? allSegmentInfo.segmentComplete.passengers[j].seat.column : '',
                            cabinIndex: 0,
                            rowIndex: 0,
                            columnIndex: 0,
                            seatTypeDescription: '',
                            seatType: ''
                        };
                        returnInfo.passengersInfo[i].currentSeat = { row: '', column: '', cabinIndex: 0, rowIndex: 0, columnIndex: 0, seatTypeDescription: '', seatType: '' };
                    }
                    j++;
                }
                if (infoFound) {
                    infoFound = false, j = 0;
                    while (!infoFound && j < returnInfo.flightMap.cabins.length) {
                        if (returnInfo.flightMap.cabins[j].enabled) {
                            k = 0;
                            while (!infoFound && k < returnInfo.flightMap.cabins[j].seatMap.length) {
                                l = 0;
                                while (!infoFound && l < returnInfo.flightMap.cabins[j].seatMap[k].rowSeats.length) {
                                    if (returnInfo.passengersInfo[i].initialSeat.row === returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].row
                                        && returnInfo.passengersInfo[i].initialSeat.column === returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].column) {
                                        infoFound = true;
                                        returnInfo.passengersInfo[i].initialSeat.cabinIndex = j;
                                        returnInfo.passengersInfo[i].initialSeat.rowIndex = k;
                                        returnInfo.passengersInfo[i].initialSeat.columnIndex = l;
                                        returnInfo.passengersInfo[i].initialSeat.seatType = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].seatType;
                                        returnInfo.passengersInfo[i].initialSeat.seatTypeDescription = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].seatTypeDescription;

                                        returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].occupation = i === returnInfo.currentPassengerIndex
                                            ? this.AncillariesConstants.SEAT_OCCUPATIONS.selection : this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser;
                                        actualSeatPrice = getActualPassengerSeatPrice(identifiers.segmentId, returnInfo.passengersInfo[i].id);
                                        returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id] = actualSeatPrice !== null
                                            ? actualSeatPrice : returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id];
                                        returnInfo.passengersInfo[i].seatPrice = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id];
                                    } else if (returnInfo.passengersInfo[i].initialSeat.row === '' && returnInfo.passengersInfo[i].initialSeat.column === '') {
                                        if (returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].occupation === this.AncillariesConstants.SEAT_OCCUPATIONS.free) {
                                            returnInfo.passengersInfo[i].initialSeat.cabinIndex = j;
                                        }
                                    }
                                    l++;
                                }
                                k++;
                            }
                        }
                        j++;
                    }
                    angular.copy(returnInfo.passengersInfo[i].initialSeat, returnInfo.passengersInfo[i].currentSeat);
                }
            }
        };

        const generateSeatInformation = () => {
            const seatsLocalStorage = this.localStorageService.get('seatsSelectedInfoData');
            const seatsLocalStorageBKIFlow: any = this.localStorageService.get('seatInfoConfirmation');
            let seatSessionInfo: any = {}, iFound = false, i = 0;
            if (seatsLocalStorage && seatsLocalStorage[seatsInfo.segmentId]) {
                seatSessionInfo = seatsLocalStorage[seatsInfo.segmentId];
            }
            if (seatsLocalStorageBKIFlow) {
                while (!iFound && i < seatsLocalStorageBKIFlow.segments.length) {
                    if (seatsLocalStorageBKIFlow.segments[i].id === seatsInfo.segmentId) {
                        seatSessionInfo = seatsLocalStorageBKIFlow.segments[i];
                        iFound = true;
                    }
                    i++;
                }
            }
            for (let i = 0; i < returnInfo.passengersInfo.length; i++) {
                let infoFound = false; j = 0;
                while (!infoFound && j < cachedInfo.order.orderItems.length) {
                    if (cachedInfo.order.orderItems[j].type === 'seat') {
                        if (cachedInfo.order.orderItems[j].passengerId === returnInfo.passengersInfo[i].id &&
                            seatsInfo.segmentId === cachedInfo.order.orderItems[j].segmentId && cachedInfo.order.orderItems[j].selected) {
                            infoFound = true;
                            for (let k = 0; k < returnInfo.flightMap.cabins.length; k++) {
                                if (returnInfo.flightMap.cabins[k].enabled) {
                                    returnInfo.passengersInfo[i].initialSeat = {
                                        row: cachedInfo.order.orderItems[j].row,
                                        column: cachedInfo.order.orderItems[j].column,
                                        cabinIndex: k,
                                        rowIndex: 0,
                                        columnIndex: 0,
                                        seatTypeDescription: '',
                                        seatType: '',
                                        selected: cachedInfo.order.orderItems[j].selected
                                    };
                                    returnInfo.passengersInfo[i].currentSeat = { row: '', column: '', cabinIndex: k, rowIndex: 0, columnIndex: 0, seatTypeDescription: '', seatType: '' };
                                }
                            }
                        }
                    } else if (seatSessionInfo && seatSessionInfo.passengers) {
                        if (seatSessionInfo && seatSessionInfo.passengers && seatsInfo.segmentId === seatSessionInfo.id && this.$rootScope.flowName === 'MMB') {
                            angular.forEach(seatSessionInfo.passengersInfo, (passengerInfo, index) => {
                                if (!seatSessionInfo.passengersInfo && seatSessionInfo.passengers) {
                                    seatSessionInfo.passengersInfo = seatSessionInfo.passengers;
                                }
                                if (passengerInfo && passengerInfo.id === returnInfo.passengersInfo[i].id && seatSessionInfo.passengersInfo[index] && seatSessionInfo.passengersInfo[index].currentSeat) {
                                    infoFound = true;
                                    for (let k = 0; k < returnInfo.flightMap.cabins.length; k++) {
                                        if (returnInfo.flightMap.cabins[k].enabled) {
                                            returnInfo.passengersInfo[i].initialSeat = {
                                                row: seatSessionInfo.passengersInfo[index].currentSeat.row,
                                                column: seatSessionInfo.passengersInfo[index].currentSeat.column,
                                                cabinIndex: k,
                                                rowIndex: 0,
                                                columnIndex: 0,
                                                seatTypeDescription: '',
                                                seatType: '',
                                                selected: ''
                                            };
                                            returnInfo.passengersInfo[i].currentSeat = { row: '', column: '', cabinIndex: k, rowIndex: 0, columnIndex: 0, seatTypeDescription: '', seatType: '' };
                                        }
                                    }
                                }
                            });
                        } else if (seatSessionInfo && seatSessionInfo.passengers && seatsInfo.segmentId === seatSessionInfo.id && this.$rootScope.flowName !== 'MMB') {
                            angular.forEach(seatSessionInfo.passengers, (passengerInfo, index) => {
                                if (!seatSessionInfo.passengersInfo && seatSessionInfo.passengers) {
                                    seatSessionInfo.passengersInfo = seatSessionInfo.passengers;
                                }
                                if (passengerInfo.id === returnInfo.passengersInfo[i].id && seatSessionInfo.passengersInfo[index].currentSeat) {
                                    infoFound = true;
                                    for (let k = 0; k < returnInfo.flightMap.cabins.length; k++) {
                                        if (returnInfo.flightMap.cabins[k].enabled) {
                                            returnInfo.passengersInfo[i].initialSeat = {
                                                row: seatSessionInfo.passengersInfo[index].currentSeat.row,
                                                column: seatSessionInfo.passengersInfo[index].currentSeat.column,
                                                cabinIndex: k,
                                                rowIndex: 0,
                                                columnIndex: 0,
                                                seatTypeDescription: '',
                                                seatType: '',
                                                selected: ''
                                            };
                                            returnInfo.passengersInfo[i].currentSeat = { row: '', column: '', cabinIndex: k, rowIndex: 0, columnIndex: 0, seatTypeDescription: '', seatType: '' };
                                        }
                                    }
                                }
                            });
                        }
                    }
                    j++;
                }
                if (infoFound) {
                    let infoFound = false, j = 0;
                    while (!infoFound && j < returnInfo.flightMap.cabins.length) {
                        if (returnInfo.flightMap.cabins[j].enabled) {
                            k = 0;
                            while (!infoFound && k < returnInfo.flightMap.cabins[j].seatMap.length) {
                                l = 0;
                                while (!infoFound && l < returnInfo.flightMap.cabins[j].seatMap[k].rowSeats.length) {
                                    if (returnInfo.passengersInfo[i].initialSeat && returnInfo.passengersInfo[i].initialSeat.row === returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].row
                                        && returnInfo.passengersInfo[i].initialSeat.column === returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].column) {
                                        infoFound = true;
                                        returnInfo.passengersInfo[i].initialSeat.cabinIndex = j;
                                        returnInfo.passengersInfo[i].initialSeat.rowIndex = k;
                                        returnInfo.passengersInfo[i].initialSeat.columnIndex = l;
                                        returnInfo.passengersInfo[i].initialSeat.seatType = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].seatType;
                                        returnInfo.passengersInfo[i].initialSeat.seatTypeDescription = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].seatTypeDescription;

                                        returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].occupation = i === returnInfo.currentPassengerIndex
                                            ? this.AncillariesConstants.SEAT_OCCUPATIONS.selection : this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser;
                                        actualSeatPrice = getActualPassengerSeatPrice(identifiers.segmentId, returnInfo.passengersInfo[i].id);
                                        returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id] = actualSeatPrice !== null
                                            ? actualSeatPrice : returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id];
                                        returnInfo.passengersInfo[i].seatPrice = returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].passengersPrice[returnInfo.passengersInfo[i].id];
                                    } else if (returnInfo.passengersInfo[i].initialSeat && returnInfo.passengersInfo[i].initialSeat.row === '' && returnInfo.passengersInfo[i].initialSeat.column === '') {
                                        if (returnInfo.flightMap.cabins[j].seatMap[k].rowSeats[l].occupation === this.AncillariesConstants.SEAT_OCCUPATIONS.free) {
                                            returnInfo.passengersInfo[i].initialSeat.cabinIndex = j;
                                        }
                                    }
                                    l++;
                                }
                                k++;
                            }
                        }
                        j++;
                    }
                    angular.copy(returnInfo.passengersInfo[i].initialSeat, returnInfo.passengersInfo[i].currentSeat);
                }
            }

            for (i = 0; i < returnInfo.passengersInfo.length; i++) {
                if (!returnInfo.passengersInfo[i].initialSeat) {
                    for (k = 0; k < returnInfo.flightMap.cabins.length; k++) {
                        if (returnInfo.flightMap.cabins[k].enabled) {
                            returnInfo.passengersInfo[i].initialSeat = {
                                row: '',
                                column: '',
                                cabinIndex: k,
                                rowIndex: 0,
                                columnIndex: 0,
                                seatTypeDescription: '',
                                seatType: ''
                            };
                            returnInfo.passengersInfo[i].currentSeat = { row: '', column: '', cabinIndex: k, rowIndex: 0, columnIndex: 0, seatTypeDescription: '', seatType: '' };
                        }
                    }
                }
            }

        };

        const getLegendInformation = (): any => {
            const listLegend = [];
            let newLegend, k;
            const getIdClassOfLegend=():string => {
                return this.AncillariesConstants.IdClassLegend[seatsInfo.seatPriceInfo.legendPrices[k].type];
            };

            const getTextOfLegend=():string=> {
                switch (seatsInfo.seatPriceInfo.legendPrices[k].type) {
                        case this.AncillariesConstants.LegendType.NORMAL: return 'CKIANCSEATS_SEAT_STANDAR';
                        case this.AncillariesConstants.LegendType.EMERGENCY: return 'CKIANCSEATS_SEAT_EMERGENCY_XL';
                        case this.AncillariesConstants.LegendType.COMFORT_SEAT: return 'SEATS_EXTRA_SIZE_SEAT';
                        case this.AncillariesConstants.LegendType.PROMO: return 'SEATS_SEAT_PROMO';
                        case this.AncillariesConstants.LegendType.UPFRONT: return 'CKIANCSEATS_SEAT_UPFRONT';
                        default: return 'CKIANCSEATS_SEAT_STANDAR';
                }
            };

            const getLegendOrder=():any => {
                switch (seatsInfo.seatPriceInfo.legendPrices[k].type) {
                        case this.AncillariesConstants.LegendType.NORMAL:
                            return this.AncillariesConstants.IdLegendOrder.NORMAL;
                        case this.AncillariesConstants.LegendType.EMERGENCY:
                            return this.AncillariesConstants.IdLegendOrder.EMERGENCY;
                        case this.AncillariesConstants.LegendType.COMFORT_SEAT:
                            return this.AncillariesConstants.IdLegendOrder.COMFORT_SEAT;
                        case this.AncillariesConstants.LegendType.PROMO:
                            return this.AncillariesConstants.IdLegendOrder.PROMO;
                        case this.AncillariesConstants.LegendType.UPFRONT:
                            return this.AncillariesConstants.IdLegendOrder.UPFRONT;
                        default: return this.AncillariesConstants.IdLegendOrder.NORMAL;
                }
            };

            const getIconName=():string => {
                switch (seatsInfo.seatPriceInfo.legendPrices[k].type) {
                        case this.AncillariesConstants.LegendType.NORMAL: return 'standard';
                        case this.AncillariesConstants.LegendType.EMERGENCY: return 'emergency';
                        case this.AncillariesConstants.LegendType.COMFORT_SEAT: return 'xl';
                        case this.AncillariesConstants.LegendType.PROMO: return 'promo';
                        case this.AncillariesConstants.LegendType.UPFRONT: return 'upfront';
                        default: return 'standard';
                }
            };
            for (let i = 0; i < this.AncillariesConstants.DynamicLegendType.length; i++) {
                for (k = 0; k < seatsInfo.seatPriceInfo.legendPrices.length; k++) {
                    if (this.AncillariesConstants.DynamicLegendType[i] === seatsInfo.seatPriceInfo.legendPrices[k].type) {
                        newLegend = seatsInfo.seatPriceInfo.legendPrices[k];
                        newLegend.price = this.CurrencyService.formatPrice(returnInfo.currency, newLegend.from, false, false, false);
                        newLegend.text = this.$filter('translate')(getTextOfLegend()) + ' - ' + this.$filter('translate')('CKIANCSEATS_FROM_PRICE_TEXT') + ' ' + newLegend.from + returnInfo.currency.currencySymbol;
                        newLegend.icon = getIconName();
                        newLegend.idClass = getIdClassOfLegend();
                        newLegend.legendOrder = getLegendOrder();
                        listLegend.push(newLegend);
                    }
                }
            }

            listLegend.sort((a, b) => a.legendOrder - b.legendOrder);

            return listLegend;
        };


        /**
         * Return if the segment is the last of booking
         */
        const isLastSegment = (): any => {
            const actualSegmenId: any = this.localStorageService.get('seatMapSegment'), availableSegments: any = this.localStorageService.get('ancillariesAvailableSegments');
            return availableSegments[availableSegments.length - 1] === actualSegmenId.segmentId;
        };

        /**
       * Generate information of seat map for show in modal confirmation
       * @param {*} segmentInfo
       * @param {*} passengers
       */
        const generateInfoSegment = (segmentInfo, passengers) => {
            const calculatePriceSeats=():any => {
                let totalPrice = 0;
                angular.forEach(segmentsSeatInfo.segments, (segment) => {
                    angular.forEach(segment.passengers, (pas) => {
                        totalPrice += angular.toJson(pas.initialSeat) === angular.toJson(pas.currentSeat) ? 0 : pas.seatPrice;
                        pas.isInitialSeat = angular.toJson(pas.initialSeat) === angular.toJson(pas.currentSeat);
                        // pas.seatPriceFormatted = this.CurrencyService.formatPrice(currency, angular.toJson(pas.initialSeat) === angular.toJson(pas.currentSeat) ? 0 : pas.seatPrice, false, false, false);
                        pas.seatPriceFormatted = angular.toJson(pas.initialSeat) !== angular.toJson(pas.currentSeat) ? this.CurrencyService.formatPrice(currency, pas.seatPrice, false, false, false) : '';
                    });
                });


                return totalPrice;
            };


            const segmentsSeatInfo: any = this.localStorageService.get('seatInfoConfirmation') || { segments: [], totalPrice: 0, totalPriceFormatted: 0 };

            if (this.localStorageService.get('seatsSelectedInfoData')) {
                const seatsLocalStorage = this.localStorageService.get('seatsSelectedInfoData')[segmentInfo.id];
            }
            const segment: any = { arrival: null, departure: null, passengers: [] }, currency: any = this.localStorageService.get('currency');
            let isFound = false;

            segment.id = segmentInfo.id;
            segment.arrival = segmentInfo.arrival;
            segment.isOut = segmentInfo.isOut;
            segment.departure = segmentInfo.departure;
            segment.passengers = passengers;

            if (segmentsSeatInfo && segmentsSeatInfo.segments.length > 0) {
                angular.forEach(segmentsSeatInfo.segments, (segmentSeat) => {
                    if (segment.id === segmentSeat.id) {
                        isFound = true;
                        segment.passengers = segmentSeat.passengers;
                    }
                });
            }

            if (!isFound) {
                segmentsSeatInfo.segments.push(segment);
            }

            segmentsSeatInfo.totalPrice = calculatePriceSeats();
            segmentsSeatInfo.totalPriceFormatted = this.CurrencyService.formatPrice(currency, segmentsSeatInfo.totalPrice, true, false, false);
            this.localStorageService.set('seatInfoConfirmation', segmentsSeatInfo);
        };

        const getPassengersSeatPrice = (passengerSeatPrices: any, seatPricesCodes: any): any => {
            const transformedSeatPrices = [];
            passengerSeatPrices = passengerSeatPrices || [];
            for (let i = 0; i < passengerSeatPrices.length; i++) {
                transformedSeatPrices[passengerSeatPrices[i].id] = getSeatPrice(passengerSeatPrices[i].seatPriceCode, seatPricesCodes);
            }
            return transformedSeatPrices;
        };
        const getPassengersOriginalType = (passengerSeatPrices: any, seatPricesCodes: any): string => {
            let originalTypes: string = '';
            passengerSeatPrices = passengerSeatPrices || [];
            if(passengerSeatPrices.length > 0) {
                originalTypes = getOriginalType(passengerSeatPrices[0].seatPriceCode, seatPricesCodes);
            }
            return originalTypes;
        };

        const getActualPassengerSeatPrice = (segmentId: any, passengerId: any): any => {
            let returnedPrice = null, iSegment = 0, iPas = 0, pasFound = false;
            const ancillariesSeatInfo: any = this.localStorageService.get('ancillariesSeatInfo') || [];
            while (!pasFound && iSegment < ancillariesSeatInfo.length) {
                if (ancillariesSeatInfo[iSegment].id === segmentId) {
                    while (!pasFound && iPas < ancillariesSeatInfo[iSegment].passengers.length) {
                        if (passengerId === ancillariesSeatInfo[iSegment].passengers[iPas].id) {
                            pasFound = true;
                            returnedPrice = ancillariesSeatInfo[iSegment].passengers[iPas].price;
                        }
                        iPas++;
                    }
                }
                iSegment++;
            }
            return returnedPrice;
        };

        const getSeatPrice = (seatPriceCode: any, seatPrices: any): any => {
            let found = false, priceIndex = 0, returnedPrice = 0;
            seatPrices = seatPrices || [];
            while (!found && priceIndex < seatPrices.length) {
                if (seatPriceCode === seatPrices[priceIndex].seatPriceCode) {
                    found = true;
                    returnedPrice = seatPrices[priceIndex].amount;
                }
                priceIndex++;
            }
            return returnedPrice;
        };

        const getOriginalType = (seatPriceCode: any, seatPrices: any): any => {
            let found = false, priceIndex = 0, returnedType = 0;
            seatPrices = seatPrices || [];
            while (!found && priceIndex < seatPrices.length) {
                if (seatPriceCode === seatPrices[priceIndex].seatPriceCode) {
                    found = true;
                    returnedType = seatPrices[priceIndex].type;
                }
                priceIndex++;
            }
            return returnedType;
        };

        const getSeatPriceLabel = (passengerSeatPrices: any, currency: any): any => {
            const seatPriceLabels = [];
            passengerSeatPrices = passengerSeatPrices || {};
            for (const i in passengerSeatPrices) {
                seatPriceLabels[i] = (passengerSeatPrices[i] > 0 ? this.CurrencyService.formatPrice(currency, passengerSeatPrices[i], false, false, false) : this.$filter('translate')('CKIANCSEATS_FREE_PRICE'));
            }
            return seatPriceLabels;
        };


        const allPassengerInfo = this.AncillariesUtilsService.isCheckinFlow() ? generatePassengerInfoCheckin(cachedInfo, Number(identifiers.pasId)) : generatePassengerInfo(cachedInfo, identifiers.pasId, orderInformation);
        const allSegmentInfo = this.AncillariesUtilsService.isCheckinFlow() ? generateSegmentInfoCheckin(Number(identifiers.segmentId), cachedInfo) : generateSegmentInfo(identifiers.segmentId, cachedInfo);
        returnInfo.passengersInfo = allPassengerInfo.passengersInfo;
        returnInfo.passengersInfo.sort((a, b) => {
            return Number(a.resiberId) - Number(b.resiberId);
        });
        returnInfo.currentPassengerIndex = allPassengerInfo.currentPassengerIndex;
        // generates view segment information
        returnInfo.segmentInfo = allSegmentInfo.returnedSegmentInfo;
        returnInfo.columnsInfo = generateColumns(seatsInfo.cabins);
        returnInfo.currency = this.localStorageService.get('currency');
        returnInfo.totalPrice = this.CurrencyService.formatPrice(returnInfo.currency, returnInfo.totalPrice, true, false, false);
        returnInfo.layoutTour3D = seatsInfo.layoutTour3D;
        if (maximumColumnSize === 4) {
            columnSize = 1;
        } else if (maximumColumnSize === 6) {
            columnSize = 2;
        } else if (maximumColumnSize === 8) {
            columnSize = 3;
        } else if (maximumColumnSize === 9) {
            columnSize = 4;
        } else if (maximumColumnSize === 10) {
            columnSize = 5;
        } else {
            columnSize = 5;
        }
        //generates directives map seat input
        seatsInfo.warningMessages = processWarningMessages(seatsInfo.warningMessages);
        returnInfo.flightMap = generateFlightMapInformation(seatsInfo, returnInfo.currency, columnSize, maximumAisles);

        if (this.AncillariesUtilsService.isCheckinFlow()) {
            generateSeatInformationCheckin();
        } else {
            generateSeatInformation();
            if(this.AncillariesUtilsService.isBookingFlow()) {
                returnInfo.pricesProvider = (seatsInfo?.pricesProvider) ? seatsInfo.pricesProvider : '';
            }
        }


        //Generate dynamic legend information
        returnInfo.legend = seatsInfo.seatPriceInfo !== null ? getLegendInformation() : [];
        returnInfo.isFirstSegment = this.isFirstSegment();
        returnInfo.isLastSegment = isLastSegment();
        generateInfoSegment(returnInfo.segmentInfo, returnInfo.passengersInfo);

        return returnInfo;
    };


    updateAncillariesInformation = (updateInfo: any, segmentId: any): void => {
        const ancillariesSeatInfo: any = this.localStorageService.get('ancillariesSeatInfo') || [];
        let i = 0, j, k, segmentFound = false, pasFound;
        const pasArray = [];

        this.AncillariesUtilsService.updateSegmentSeatStatus(updateInfo, segmentId);
        while (!segmentFound && i < ancillariesSeatInfo.length) {
            if (ancillariesSeatInfo[i].id === segmentId) {
                segmentFound = true;
                for (j = 0; j < updateInfo.length; j++) {
                    k = 0, pasFound = false;
                    while (!pasFound && k < ancillariesSeatInfo[i].passengers.length) {
                        if (updateInfo[j].id === ancillariesSeatInfo[i].passengers[k].id) {
                            pasFound = true;
                            ancillariesSeatInfo[i].passengers[k].price = updateInfo[j].price;
                        }
                        k++;
                    }
                    if (!pasFound) {
                        ancillariesSeatInfo[i].passengers.push({ id: updateInfo[j].id, price: updateInfo[j].price });
                    }
                }
            }
            i++;
        }
        if (!segmentFound) {
            for (j = 0; j < updateInfo.length; j++) {
                pasArray.push({ id: updateInfo[j].id, price: updateInfo[j].price });
            }
            ancillariesSeatInfo.push({ id: segmentId, passengers: pasArray });
        }
        this.localStorageService.set('ancillariesSeatInfo', ancillariesSeatInfo);
    };

    /**
    * Update information of seat map confirmation info
    * @param {Object} updateInfo
    */
    updateSeatCheckinInformation = (updateInfo: any): void => {
        const segmentsSeatInfo: any = this.localStorageService.get('seatInfoConfirmation');
        const segmentUpdated: any = this.localStorageService.get('seatMapSegment');
        const currency: any = this.localStorageService.get('currency');

        angular.forEach(segmentsSeatInfo.segments, (segment) => {
            if (segment.id === Number(segmentUpdated.segmentId)) {
                for (let i = 0; i < segment.passengers.length; i++) {
                    for (let k = 0; k < updateInfo.length; k++) {
                        if (segment.passengers[i].id === updateInfo[k].id) {
                            segment.passengers[i].currentSeat.row = updateInfo[k].seat.row;
                            segment.passengers[i].currentSeat.column = updateInfo[k].seat.column;
                            segment.passengers[i].currentSeat.seatType = updateInfo[k].seatType;
                            segment.passengers[i].currentSeat.seatTypeDescription = updateInfo[k].seatTypeDescription;
                            segment.passengers[i].isInitialSeat = angular.toJson(segment.passengers[i].initialSeat) === angular.toJson(segment.passengers[i].currentSeat);
                            segment.passengers[i].seatPrice = updateInfo[k].price;
                            segment.passengers[i].seatPriceFormatted = updateInfo[k].price > 0 ? this.CurrencyService.formatPrice(currency, updateInfo[k].price, false, false, false) : '';
                        }
                    }
                }
            }
        });

        const calculateTotalSeatPrices=(segmentsInfo:any, currency:any) => {
            let totalPrice = 0;
            angular.forEach(segmentsInfo.segments, (segment) => {
                angular.forEach(segment.passengers, (pas) => {
                    if (!pas.isInitialSeat) {
                        totalPrice += pas.seatPrice;
                    }
                });
            });
            segmentsInfo.totalPrice = totalPrice;
            segmentsInfo.totalPriceFormatted = this.CurrencyService.formatPrice(currency, segmentsInfo.totalPrice, true, false, false);
        };
        calculateTotalSeatPrices(segmentsSeatInfo, currency);

        this.localStorageService.set('seatInfoConfirmation', segmentsSeatInfo);

    };


    /**
     * Update seat information of localStorage
     * @param {Array} updateInfo Segments where the seats were updated.
     */
    updateSeatInformation = (updateInfo: any): any => {
        const segmentsSeatInfo: any = this.localStorageService.get('seatInfoConfirmation');
        const currency: any = this.localStorageService.get('currency');

        segmentsSeatInfo.segments.forEach((segment: any) => {
            Object.keys(updateInfo).forEach((segmentUpdate: any)=> {
                if(segment.id === segmentUpdate) {
                    segment.passengers.forEach((passenger: any) => {
                        if(updateInfo[segmentUpdate] && updateInfo[segmentUpdate][passenger.id] && passenger.id === updateInfo[segmentUpdate][passenger.id].id) {
                            passenger.currentSeat.row = updateInfo[segmentUpdate][passenger.id].seat.row;
                            passenger.currentSeat.column = updateInfo[segmentUpdate][passenger.id].seat.column;
                            passenger.currentSeat.seatType = updateInfo[segmentUpdate][passenger.id].seat.seatType;
                            passenger.currentSeat.seatTypeDescription = updateInfo[segmentUpdate][passenger.id].seat.seatTypeDescription;
                            passenger.currentSeat.isInitialSeat = angular.toJson(passenger.initialSeat === angular.toJson(passenger.currentSeat));
                            passenger.currentSeat.seatPrice = updateInfo[segmentUpdate][passenger.id].price;
                            passenger.currentSeat.seatPriceFormatted = updateInfo[segmentUpdate][passenger.id].price > 0 ? this.CurrencyService.formatPrice(currency, updateInfo[segmentUpdate][passenger.id].price, false, false, false) : '';
                        }
                    });
                }
            });
        });


        const calculateTotalSeatPrices=(segmentsInfo: any, currency: any)=> {
            let totalPrice = 0;
            angular.forEach(segmentsInfo.segments, (segment) => {
                angular.forEach(segment.passengers, (pas) => {
                    if (!pas.isInitialSeat) {
                        totalPrice += pas.seatPrice;
                    }
                });
            });
            segmentsInfo.totalPrice = totalPrice;
            segmentsInfo.totalPriceFormatted = this.CurrencyService.formatPrice(currency, segmentsInfo.totalPrice, true, false, false);
        };
        segmentsSeatInfo !== null ? calculateTotalSeatPrices(segmentsSeatInfo, currency) : segmentsSeatInfo;

        this.localStorageService.set('seatInfoConfirmation', segmentsSeatInfo);

    };


    /**
     * Return the length of available segments for show seat map
     */
    isFirstSegment = (): any => {
        const actualSegmenId: any = this.localStorageService.get('seatMapSegment'), availableSegments = this.localStorageService.get('seatsAvailableSegments');
        return availableSegments[0] === actualSegmenId.segmentId.toString();
    };

    /**
     * Creación de metodo que devuelve la estructura con el ID correcto
     * para que se pueda hacer su transformer correspondiente
     * @param passen
     * @returns
     */
    genStructureForCKIAncillaries = (type, passen) => {
        if(type === 'CKI') {
            const pass: any = this.localStorageService.get('bookingInfo');
            const LS_passenger = pass.passengers;
            passen.segments[0].passengers.forEach((myObject, index) => {
                LS_passenger[index].id < 10 ? LS_passenger[index].id = '0' + LS_passenger[index].id : LS_passenger[index].id;
                myObject.id = LS_passenger[index].type + '_' + LS_passenger[index].id;
            });
        }

        return passen;
    };

    genAviosSeatReq = (selectedSeats, seatData, segmentId): AncillariesModel.AviosAncillaries[] => {
        const ancillariesSlices: any[] = this.localStorageService.get('ancillariesSlices');
        const idBuilder = (id:number)=>{
            const info:any = this.localStorageService.get('summaryInfo') || null;
            if(info === null) return id;
            const passengerInfo = info.context?.passengers?.find(passenger => id.toString() === passenger.id);
            return id > 10 ? passengerInfo.passengerType + '_' + id : passengerInfo.passengerType + '_0' + id;

        };

        const seatObj = {
            id: typeof seatData.id === 'number' ? idBuilder(seatData.id) : seatData.id,
            ancillaries: [{
                type: this.AncillariesConstants.TYPE_ANCILLARIE.SEAT,
                slices: [{
                    id: ancillariesSlices.find(slice => slice.segmentIds.includes(segmentId.toString()))?.id,
                    segments: [{
                        id: segmentId,
                        amounts: [{fare: seatData.price, quantity: 1}]
                    }]
                }]
            }]
        };
        const getIndex = (arr: any[], id: string) => arr.findIndex((el) => el.id === id);
        const i = getIndex(selectedSeats, seatObj.id);
        if (i >= 0) {
            const j = getIndex(selectedSeats[i].ancillaries[0].slices, seatObj.ancillaries[0].slices[0].id);
            if (j >= 0) {
                const k = getIndex(selectedSeats[i].ancillaries[0].slices[j].segments, seatObj.ancillaries[0].slices[0].segments[0].id);
                if (k >= 0) {
                    selectedSeats[i].ancillaries[0].slices[j].segments[k] = seatObj.ancillaries[0].slices[0].segments[0];
                } else {
                    selectedSeats[i].ancillaries[0].slices[j].segments.push(seatObj.ancillaries[0].slices[0].segments[0]);
                }
            } else {
                selectedSeats[i].ancillaries[0].slices.push(seatObj.ancillaries[0].slices[0]);
            }
        } else {
            selectedSeats.push(seatObj);
        }
        return selectedSeats;
    };

    deleteAviosUnselectedSeat = (segmentId: any, passengerId: any) => {
        const aviosInfo: any = this.localStorageService.get('genAviosAncillariesSeat');
        aviosInfo.forEach(passenger => {
            if (passenger.id === passengerId && passenger.ancillaries) {
                passenger.ancillaries.forEach(ancillarie => {
                    if(ancillarie.type === 'SEAT') {
                        ancillarie.slices.forEach(slice => {
                            slice.segments = slice.segments.filter((segment) => segment.id !== segmentId);
                        });
                        ancillarie.slices = ancillarie.slices.filter((slice) => slice.segments.length > 0);
                    }
                });
                passenger.ancillaries = passenger.ancillaries.filter((ancillarie) => ancillarie.slices.length > 0);
            }
        });
        return aviosInfo.filter((passenger) => passenger.ancillaries.length > 0);
    };

    genAviosSeatAncillariesReq = (ancillariesArr: any[]) => {
        const flightInfo: any = this.localStorageService.get('flightAviosInfo');
        flightInfo.passengers.forEach(passenger => {
            const ancillary = ancillariesArr.find(anci => anci.id === passenger.id);
            delete passenger.flight;
            if (ancillary) {
                passenger.ancillaries = ancillary.ancillaries;
            }else{
                passenger.ancillaries = [];
            }
        });
        return flightInfo;
    };

    showReductedMovilityBanner = () => {
        let showMessage = false;
        const specialNeeds: Array<string> = ['DEAF', 'BLND', 'WCHR', 'WCHS', 'WCHC', 'SVAN'];
        let summaryInfo: any = this.localStorageService.get('summaryInfo');
        let hasSpecialNeeds: boolean = false;
        let italyIsIncluded: boolean = false;
        let issueCountryIsItaly: boolean = false;

        if (!summaryInfo) {
            summaryInfo = this.localStorageService.get('breakdownInfo');
        }
        if (summaryInfo) {
            if (summaryInfo.context.passengers.length > 1) {
                angular.forEach(summaryInfo.context.passengers, (pass) => {
                    if (pass.passengerType === 'CHILD' || specialNeeds.includes(pass.items[0])) {
                        hasSpecialNeeds = true;
                    }
                });
                if (this.$window.datalayer_general.trayectoPais) {
                    italyIsIncluded = this.$window.datalayer_general.trayectoPais.split('-').some(pais => pais === 'IT');
                    if (!italyIsIncluded) {
                        italyIsIncluded = this.$window.datalayer_general.mercado === 'IT';
                    }
                } else {
                    const flightsInfo = this.localStorageService.get('flightsInfo');
                    if (flightsInfo !== null) {
                        angular.forEach(flightsInfo, (flight) => {
                            if (flight.arrivalCity.city.country.code === 'IT' || flight.departureCity.city.country.code === 'IT') {
                                italyIsIncluded = true;
                            }
                        });
                    } else {
                        const bookingInfo: any = this.localStorageService.get('bookingInfo');
                        if (bookingInfo) {
                            if (bookingInfo.outwardSegments) {
                                for (let i = 0; i < bookingInfo.outwardSegments.length; i++) {
                                    if (bookingInfo.outwardSegments[i].arrival.airport.country === 'IT' || bookingInfo.outwardSegments[i].departure.airport.country === 'IT') {
                                        italyIsIncluded = true;
                                    }
                                }
                            }
                        }
                    }
                    const ancillariesSummary: any = this.localStorageService.get('breakdownInfo');
                    if (ancillariesSummary) {
                        if (ancillariesSummary.context.issueCountry === 'IT') {
                            issueCountryIsItaly = true;
                        }
                    } else {
                        const ancillariesSummaryCKI: any = this.localStorageService.get('summaryInfo');
                        if (ancillariesSummaryCKI) {
                            if (ancillariesSummaryCKI.context.issueCountry === 'IT') {
                                issueCountryIsItaly = true;
                            }
                        }
                    }
                }
                if ((italyIsIncluded || issueCountryIsItaly) && hasSpecialNeeds) {
                    showMessage = true;
                }
            }
        }
        return showMessage;
    };
}

NewSeatsMapTransformer.$inject =
    ['$rootScope',
        '$filter',
        'AncillariesUtilsService',
        'AncillariesConstants',
        'CurrencyService',
        'localStorageService',
        '$window'];
try {
    const mod = angular.module('ib-new-seat-map-module');
    mod.service(
        'NewSeatsMapTransformer',
        NewSeatsMapTransformer
    );
} catch (error) {
    const mod = angular.module('ib-new-seat-map-module', []);
    mod.service(
        'NewSeatsMapTransformer',
        NewSeatsMapTransformer
    );
}